import { onMounted } from "vue";
import { setCookie, getCookie } from "@/utils/cookies";
import { speedTest } from "@/utils/speedTest";
import { getOfficialDomainAPI } from "@/api";
import store from "@/store";

export const useFastOfficialDomain = () => {
  let fastUrl;
  onMounted(async () => {
    fastUrl = await getFastDomain();
  });
  return { fastUrl }
};

/**由api取得的官網domain清單進行測速
 * 超過五分鐘或原有的網址己經不通則重新測速
*/
export const getFastDomain = async () => {
  let fastUrl;
  try {
    const platform = store.getters.isH5View ? "H5" : "PC";
    let { fastUrl:fastUrlFromCookies = undefined, lastSpeedTestTimeStamp = 0, urls = undefined } = JSON.parse(getCookie(`officialDomain`)) || {};
    const duration = Math.ceil((new Date().getTime() - lastSpeedTestTimeStamp) / (1000 * 60))
    //對己緩存domain測試存活
    if(fastUrlFromCookies) {
      const fastUrlAlive = await speedTest([fastUrlFromCookies + '/domain_status/'])
      if (fastUrlAlive && duration < 5) {
        return fastUrlFromCookies;
      }
    }

    if(!urls) {
      const { head, body } = await getOfficialDomainAPI();
      if (head.errCode !== 0) {
        throw new Error({ errCode: head.errCode, errMsg: head.errMsg });
      }
      urls = platform === "PC" ? body.official : body.official_mobile;
      /*TODO: test */
      //urls = [...['http://localhost:3002', 'http://localhost:3003', '  '], ...urls]
      urls = urls.map(url=>(url+'').replace(/\s/g, '')).filter(Boolean);
    }
    fastUrl = await speedTest(urls.map(url=>url+'/domain_status/'));
    if (fastUrl) {
      fastUrl = fastUrl.replace('/domain_status/', '');
      const settingData = JSON.stringify({ fastUrl, urls, lastSpeedTestTimeStamp: new Date().getTime() })
      setCookie(`officialDomain`, settingData, 60 * 60 * 1)
    }
  } catch (error) {
    console.log(error);
  }
  return fastUrl;
};